﻿import {kebabCase} from "@2d-front-monorepo/core";
import ApprovalStatus from "../enums/ApprovalStatus";
import PaymentStatus from "../enums/PaymentStatus";
import ReservationStatusType from "../enums/ReservationStatusType";
import ReservationType from "../enums/ReservationType";
import {
	AttachmentStatus,
	AttachmentType,
	ParkingPrebookingAvailabilityType, PaymentMethod,
	PermitStatusType,
	ReservationBlockType
} from "../index";
import {PermitEntityResult} from "../types/PermitEntityResult";

export function approvalStatusName<T>(permit: PermitEntityResult<T>): string {
	return kebabCase(ApprovalStatus[permit.status]);
}

export function approvalStatusLabel<T>(permit: PermitEntityResult<T>): string {
	if (permit.status == ApprovalStatus.Undefined) {
		return "";
	}

	return `approval-status--${approvalStatusName(permit)}`;
}

export function permitStatusName(permitStatus: PermitStatusType): string {
	return kebabCase(PermitStatusType[permitStatus]);
}

export function permitStatusLabel(permitStatus: PermitStatusType): string {
	if (permitStatus == PermitStatusType.Undefined) {
		return "";
	}

	return `permit-status--${permitStatusName(permitStatus)}`;
}

export function reservationStatusName(reservationStatus: ReservationStatusType): string {
	return kebabCase(ReservationStatusType[reservationStatus]);
}

export function reservationStatusLabel(reservationStatus: ReservationStatusType): string {
	if (reservationStatus == ReservationStatusType.Undefined) {
		return "";
	}

	return `reservation-status--${reservationStatusName(reservationStatus)}`;
}

export function reservationTypeName(reservationType: ReservationType): string {
	return kebabCase(ReservationType[reservationType]);
}

export function reservationTypeLabel(reservationType: ReservationType): string {
	if (reservationType == ReservationType.Undefined) {
		return "";
	}

	return `reservation-type--${reservationTypeName(reservationType)}`;
}

export function attachmentStatusName(attachmentStatus: AttachmentStatus): string {
	return kebabCase(AttachmentStatus[attachmentStatus]);
}

export function attachmentStatusLabel(attachmentStatus: AttachmentStatus): string {
	if (attachmentStatus == AttachmentStatus.Undefined) {
		return "";
	}

	return `attachment-status--${attachmentStatusName(attachmentStatus)}`;
}

export function attachmentTypeName(attachmentType: AttachmentType): string {
	return kebabCase(AttachmentType[attachmentType]);
}

export function attachmentTypeLabel(attachmentType: AttachmentType): string {
	if (attachmentType == AttachmentType.Undefined) {
		return "";
	}

	return `attachment-type--${attachmentTypeName(attachmentType)}`;
}

export function parkingPrebookingAvailabilityTypeName(availabilityType: ParkingPrebookingAvailabilityType): string {
	return kebabCase(ParkingPrebookingAvailabilityType[availabilityType]);
}

export function parkingPrebookingAvailabilityTypeLabel(availabilityType: ParkingPrebookingAvailabilityType): string {
	if (availabilityType == ParkingPrebookingAvailabilityType.Undefined) {
		return "";
	}

	return `availability-type--${parkingPrebookingAvailabilityTypeName(availabilityType)}`;
}


export function reservationBlockTypeName(blockType: ReservationBlockType): string {
	return kebabCase(ReservationBlockType[blockType]);
}

export function reservationBlockTypeLabel(blockType: ReservationBlockType): string {
	if (blockType == ReservationBlockType.Undefined) {
		return "";
	}

	return `block-type--${reservationBlockTypeName(blockType)}`;
}

export function paymentMethodName(payWith: PaymentMethod): string {
	return kebabCase(PaymentMethod[payWith]);
}

export function paymentMethodLabel(payWith: PaymentMethod): string {
	if (payWith == PaymentMethod.Undefined) {
		return "";
	}

	return `payment-method--${paymentMethodName(payWith)}`;
}


export function paymentStatusName(paymentStatus: PaymentStatus): string {
	return kebabCase(PaymentStatus[paymentStatus]);
}

export function paymentStatusLabel(paymentStatus: PaymentStatus): string {
	if (paymentStatus == PaymentStatus.NoPayment) {
		return "";
	}

	return `payment-status--${paymentStatusName(paymentStatus)}`;
}
